@if (activeBanners.length > 0 && currentBanner) {
<div class="w-full flex items-center gap-3 px-4 py-2.5 text-sm"
    [ngClass]="[getBannerBgClass(currentBanner.severity), getTextClass(currentBanner.severity)]">

    <app-icon [type]="getIconName(currentBanner.severity)" source="lucide" size="sm"
        [class]="getIconClass(currentBanner.severity)" />

    <div class="flex-1 flex items-center gap-1.5 min-w-0">
        <!-- @if (currentBanner.title) {
        <span class="font-semibold flex-shrink-0">{{ currentBanner.title }}</span>
        } -->
        <span class="font-medium flex-shrink-0">{{ currentBanner.description }}</span>
        @if (currentBanner.ctaText && currentBanner.ctaLink) {
        <a [href]="currentBanner.ctaLink" target="_blank" rel="noopener noreferrer"
            class="underline font-medium ml-1 flex-shrink-0 hover:opacity-80">
            {{ currentBanner.ctaText }}
        </a>
        }
    </div>

    @if (activeBanners.length > 1) {
    <div class="flex items-center gap-1 flex-shrink-0">
        <app-button icon="chevron-left" iconSource="lucide" iconSize="sm" variant="ghost" size="sm"
            [disabled]="currentIndex === 0" (clicked)="prev()" />
        <span class="text-xs font-medium px-1">{{ currentIndex + 1 }} / {{ activeBanners.length }}</span>
        <app-button icon="chevron-right" iconSource="lucide" iconSize="sm" variant="ghost" size="sm"
            [disabled]="currentIndex === activeBanners.length - 1" (clicked)="next()" />
    </div>
    }

</div>
}